<script>
import ApiService from "../utils/ApiService";
export default {
    name: "DialogImportExcel",
    data() {
        return {
            visible: false,
            form_type: 'rtb7',
            file: {},
            formTypes: [
                {
                    label: 'Inspection Report',
                    value: 'inspection-report'
                },
                {
                    label: 'Notice of Rent Increase',
                    value: 'rtb7'
                }
            ],
            sending: false
        }
    },
    methods: {
        open() {
            this.visible = true;
        },
        close() {
            this.visible = false;
        },
        submit() {
            console.log(this.file);
            const formData = new FormData();
            formData.append('form_type', this.form_type);
            formData.append('file', this.file);

            this.sending = true;
            ApiService.post('/sterling/forms/import', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                this.visible = false;
                this.$emit('success');
                this.$message.success('Imported successfully');
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.sending = false;
            });
        }
    }
}
</script>

<template>
    <el-dialog title="Import Excel"
               closeable
               :visible.sync="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="close"
    >
        <el-form label-width="120px" size="medium">
            <el-form-item label="Report Type">
                <el-select v-model="form_type" placeholder="Select">
                    <el-option v-for="item in formTypes" :key="item.value" :label="item.label" :value="item.value"/>
                </el-select>
            </el-form-item>
            <el-form-item label="Excel File">
                <input type="file" rel="fileinput" @change="file = $event.target.files[0]"/>
            </el-form-item>
            <el-form-item>
                <el-button :disabled="!file.name" :loading="sending" type="primary" @click="submit">Upload & Import
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<style scoped>

</style>